export { _BASIC_CONFIG }

const _BASIC_CONFIG = {
  debug: true
}
